import React from 'react'
import styled from '@emotion/styled'

import {CommonTextStyles} from '../utils/styles'

// Theme
import theme from '../utils/theme';


const Footer = styled('footer')`
  ${CommonTextStyles};
  //background-color: #000;
  //color: #fff;
  padding: 60px 15px 25px;
  //padding-top: 60px;
  min-height: calc(var(--real100vh) + 2px);
  display: flex;
  flex-direction: column; 

  p {
    margin-top: 0;
  }

  h3 {
    font-size: inherit;
    margin: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  @media ${theme.breakpoints.md} {
    //display: flex;
    //flex-direction: column; 
    //min-height: 100vh;
    padding: 120px 20px 25px;
  }
`

const Credits = styled('div')`
  display: flex;
  align-items: flex-end;
  
  margin-top: auto;
  height: 180px;

  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0;

  @media ${theme.breakpoints.md} { 
    margin-top: auto;
  }
`


const FooterComponent = () => {
  
  return (
    <Footer>
      <p>
        <i>Office</i><br/>
        Studio Jens Assur<br/>
        Karolinervägen 80<br/>
        837 71 Duved, Sweden<br/><br/>

        <i>Stockholm Office</i><br/>
        Studio Jens Assur<br/>
        Eastmansvägen 12<br/>
        113 61 Stockholm<br/><br/>
        <a href="tel:+46708111145">+46 (0) 708 11 11 45</a><br/>
        <a href="mailto:info@assur.se">info@assur.se</a>
      </p>

      <p>
        <i>For Art inquiries</i><br/>
        <a href="tel:+46707483672">+46 (0) 707 48 36 72</a><br/>
        <a href="mailto:jennie@assur.se">jennie@assur.se</a>
      </p>

      <p>
        <i>Social media</i><br/>
        <a href="https://www.instagram.com/jensassur">Instagram</a>
      </p>

      <Credits>
        <div>
          Design by <a href="https://www.parasol-projects.com/">Parasol</a><br/>
          Code by <a href="https://www.persturesson.com/">Per Sturesson</a>
        </div>
      </Credits>
    </Footer>
  )
}

export default FooterComponent